module.exports = __webpack_public_path__ + "img/gaku_btn_09.cf50b4bd.png";